import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { Navbar } from "../components/Navbar";
import { LegalFooter } from "../components/LegalFooter";

export function AppLayout() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <Box sx={{ flex: 1, pt: { xs: 7, sm: 8 } }}>
        <Box
          component="main"
          sx={{
            p: { xs: 1.5, sm: 2, md: 4 },
            maxWidth: 1280,
            mx: "auto",
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <LegalFooter />
    </Box>
  );
}
